import React from "react"

class ErrorBoundary extends React.Component {
  state = {
    hasError: false,
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service like Sentry etc.
    console.log("Error Boundary")
    console.log(error)
    // console.log(JSON.stringify(errorInfo, null, 4));
    this.setState({ errorInfo })
    console.log("----- ----- -----")
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI.
      return (
        <h2 className="text-center">
          This Section Is Temporarily Unavailable.
        </h2>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
